
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import styled, { css } from 'styled-components';
import React from 'react';
import { grey } from '@material-ui/core/colors';

const StyledNavbar = styled.div`
  background: #fff;
  text-align: center;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  z-index: 10;
  display: grid;
  grid-gap: 8px;
  grid-template-rows: auto 1fr auto;
  min-height: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  
  ${props => props.$collapsed && css`
    grid-template-rows: auto auto 1fr;
  `}
`;

const CollapseBarWrapper = styled.div`
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  padding: 6px;
`;

const CollapseBar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  cursor: pointer;
  user-select: none;
  height: 34px;
  border: 1px solid #fff;
  border-radius: 4px;

  &:hover {
    background: ${grey[200]}
  }
`;

const TopToolbar = styled.div`
  padding-top: 6px;
  min-width: 0;
`;

const BottomToolbar = styled.div`
  display: flex;
  flex-direction: column;
`;


function Navbar({
  topToolbar,
  bottomToolbar,
  menu,
  navbarProps,
  collapsed = false,
  onToggleCollapse
}) {
  return (
    <StyledNavbar
      {...navbarProps}
      $collapsed={collapsed}
    >
      <CollapseBarWrapper>
        <CollapseBar
          onClick={() => onToggleCollapse?.()}
          role="button"
          aria-label={collapsed ? 'Развернуть меню' : 'Свернуть меню'}
          aria-expanded={!collapsed}
        >
          {collapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </CollapseBar>
      </CollapseBarWrapper>
      <TopToolbar>
        {!collapsed && topToolbar}
        <div>
          {menu}
        </div>
      </TopToolbar>
      <BottomToolbar>
        {bottomToolbar}
      </BottomToolbar>
    </StyledNavbar>
  );
}

export default Navbar;
